import { create } from 'zustand';

const useTimeStore = create(set => ({
  drawerWidth: 100 / 3,
  setDrawerWidth: drawerWidth => set({ drawerWidth }),
  boton1: false,
  setBoton1: boton1 => set({ boton1 }),
  boton2: false,
  setBoton2: boton2 => set({ boton2 }),
  casos: ['Map', 'LayersControl', 'Nada', 'NavBar', 'BotonMenu', 'BotonEditor', 'LocationMenu'],
  setCasos: casos => set({ casos }),
  centerMap: {},
  setCenterMap: centerMap => set({ centerMap }),
  adjustMap: true,
  setAdjustMap: adjustMap => set({ adjustMap }),
  coordsAnnotationTemplate: {},
  setCoordsAnnotationTemplate: coordsAnnotationTemplate => set({ coordsAnnotationTemplate }),
  dataToSend: {},
  setDataToSend: dataToSend => set({ dataToSend }),
  coordOnMap: {},
  setCoordOnMap: coordOnMap => set({ coordOnMap }),
  data: {},
  setData: data => set({ data }),
  drawRoute: {},
  setDrawRoute: drawRoute => set({ drawRoute }),
  edicion: false,
  setEdicion: edicion => set({ edicion }),
  elemento: 0,
  setElemento: elemento => set({ elemento }),
  goToCoordinates: [0, 0],
  setGoToCoordinates: goToCoordinates => set({ goToCoordinates }),
  isMapLoaded: false,
  setIsMapLoaded: isMapLoaded => set({ isMapLoaded }),
  layers: [],
  setLayers: layers => set({ layers }),
  layersTrans: [],
  setLayersTrans: layersTrans => set({ layersTrans }),
  mapTypeView: 'map',
  setMapTypeView: mapTypeView => set({ mapTypeView }),
  pointsRoute: [],
  setPointsRoute: pointsRoute => set({ pointsRoute }),
  geometryConfig: 'none',
  setGeometryConfig: geometryConfig => set({ geometryConfig }),
  save: false,
  setSave: save => set({ save }),
  isSideBySide: false,
  setIsSideBySide: isSideBySide => set({ isSideBySide }),
  layerSide: { left: [], right: [] },
  setLayerSide: layerSide => set({ layerSide }),
  showNotesOnMap: {
    updateMap: false,
    showEnable: false,
    enableCenter: false,
    annotations: [],
    selectAnnotation: {},
    videos: [],
    selectVideo: {},
    methodEditor: 'close',
    proyectedPoint: {},
    handleAnnotation: () => {}
  },
  setShowNotesOnMap: showNotesOnMap => set({ showNotesOnMap })
}));

export default useTimeStore;
